export enum ApplyViaOptions {
  SEEK_WEBSITE = 'seekWebsite',
  EXTERNAL_WEBSITE = 'externalWebsite',
}
